import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/page.tsx");
